import {UseInfiniteQueryResult, UseSuspenseInfiniteQueryResult} from "@tanstack/react-query";
import {useInView} from "react-intersection-observer";

const useInViewWithQuery = (
  query: UseInfiniteQueryResult<unknown, unknown> | UseSuspenseInfiniteQueryResult<unknown, unknown>,
) =>
  useInView({
    onChange: async inView => {
      if (inView && !query.isFetching && query.hasNextPage) {
        query.fetchNextPage();
      }
    },
  });

export {useInViewWithQuery};
